import { Employee } from "~/components/Employee";
import { Text } from "~/components/Text";
import { getFullName } from "~/utils/getFullName";

interface EmployeeSummaryProps extends React.ComponentProps<typeof Employee> {
  showPlaceholder?: boolean;
  showLabel?: boolean;
}

export function EmployeeSummary({ showLabel, showPlaceholder, ...employee }: EmployeeSummaryProps) {
  const fullName = getFullName(employee);

  if (!fullName && !showPlaceholder) {
    return null;
  }

  return (
    <div className="grid gap-3xs" data-component="EmployeeSummary">
      {showLabel && (
        <span className="text-sm font-semibold">
          <Text i18nKey="summary.agent" />
        </span>
      )}
      <Employee {...employee} />
    </div>
  );
}
